var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { dataTableConfigFields } from '../../DataTable/DataTableFormioIntegration';
export default __spreadArrays([
    {
        type: 'textfield',
        label: 'Image Url',
        input: true,
        key: 'imageUrl',
        weight: 20,
    },
    {
        type: 'textfield',
        label: 'Width',
        input: true,
        key: 'canvasWidth',
        weight: 20,
    },
    {
        type: 'textfield',
        label: 'Height',
        input: true,
        key: 'canvasHeight',
        weight: 20,
    },
    {
        type: 'textfield',
        label: 'Dot Size',
        input: true,
        key: 'dotSize',
        placeholder: '10',
        weight: 20,
    },
    {
        type: 'textfield',
        label: 'Dot Stroke Size',
        input: true,
        key: 'dotStrokeSize',
        placeholder: '2',
        weight: 20,
    },
    {
        type: 'textfield',
        label: 'Dot Stroke Color',
        input: true,
        key: 'dotStrokeColor',
        placeholder: '#333',
        weight: 20,
    },
    {
        type: 'textfield',
        label: 'Dot Fill Color',
        input: true,
        key: 'dotFillColor',
        placeholder: '#ccc',
        weight: 20,
    },
    {
        type: 'textfield',
        label: 'Dot Custom Label',
        input: true,
        key: 'dotCustomLabel',
        placeholder: 'x',
        tooltip: 'Custom static label for dot.',
        weight: 20,
    }
], dataTableConfigFields());
